const initState = {
    activeTabIndex: 0,
    glossaries: null,
    wishListId: undefined,
    entries: [],
    isMarkAsConsumedClicked: false,
    isReportStockDiscrepancyClicked: false,
    isConsumptionSummaryEditClicked: false,
    selectedProductInstances: [],
    selectedLotSerialInstances: [],
    searchData: {
        scanSearchEnabled: {
            overview: false,
            viewByProductCode: false,
            viewByLotNumber: false,
            registerConsumption: true,
        },
        searchTerm: {
            viewByProductCode: '',
            viewByLotNumber: '',
        },
    },
    patientDetails: {
        patientID: '',
        procedureID: '',
        hospitalCostCenter: '',
        surgeon: '',
    },
};

const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
const SET_GLOSSARIES = 'SET_GLOSSARIES';
const UPDATE_HASH = 'UPDATE_HASH';
const SET_REGISTER_CONSUMPTION_WISHLIST = 'SET_REGISTER_CONSUMPTION_WISHLIST';
const SET_CONSUMPTION_CARTLIST = 'SET_CONSUMPTION_CARTLIST';
const SET_SELECTED_PRODUCT_INSTANCES = 'SET_SELECTED_PRODUCT_INSTANCES';
const SET_SELECTED_LOT_SERIAL_INSTANCES = 'SET_SELECTED_LOT_SERIAL_INSTANCES';
const SET_IS_MARK_AS_CONSUMED_CLICKED = 'SET_IS_MARK_AS_CONSUMED_CLICKED';
const SET_IS_CONSUMPTION_SUMMARY_EDIT_CLICKED = 'SET_IS_CONSUMPTION_SUMMARY_EDIT_CLICKED';
const SET_SCAN_SEARCH_ENABLED = 'SET_SCAN_SEARCH_ENABLED';
const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
const SET_PATIENT_DETAILS = 'SET_PATIENT_DETAILS';

export const setCurrenttab = (data) => ({ type: SET_ACTIVE_TAB, payload: data });
export const setGlossaries = (data) => ({ type: SET_GLOSSARIES, payload: data });
export const updateHash = (data) => ({ type: UPDATE_HASH, payload: data });
// TODO: Needs to create a standalone registerConsumptionReducer later for future tickets ;)
export const setRegisterConsumptionWishlist = (data) => ({
    type: SET_REGISTER_CONSUMPTION_WISHLIST,
    payload: data,
});
export const setConsumptionCartlist = (data) => ({ type: SET_CONSUMPTION_CARTLIST, payload: data });
export const setSelectedProductInstances = (data) => ({
    type: SET_SELECTED_PRODUCT_INSTANCES,
    payload: data,
});
export const setSelectedLotSerialInstances = (data) => ({
    type: SET_SELECTED_LOT_SERIAL_INSTANCES,
    payload: data,
});
export const setIsMarkAsConsumedClicked = (data) => ({
    type: SET_IS_MARK_AS_CONSUMED_CLICKED,
    payload: data,
});
export const setIsConsumptionSummaryEditClicked = (data) => ({
    type: SET_IS_CONSUMPTION_SUMMARY_EDIT_CLICKED,
    payload: data,
});
export const setScanSearchEnabled = (data) => ({ type: SET_SCAN_SEARCH_ENABLED, payload: data });
export const setSearchTerm = (data) => ({ type: SET_SEARCH_TERM, payload: data });
export const setPatientDetails = (data) => ({ type: SET_PATIENT_DETAILS, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_ACTIVE_TAB:
            return { ...state, activeTabIndex: action.payload };
        case SET_GLOSSARIES:
            return { ...state, glossaries: action.payload };
        case UPDATE_HASH:
            return { ...state, ...action.payload };
        case SET_REGISTER_CONSUMPTION_WISHLIST:
            return { ...state, wishListId: action.payload };
        case SET_CONSUMPTION_CARTLIST:
            return { ...state, entries: action.payload };
        case SET_SELECTED_PRODUCT_INSTANCES:
            return { ...state, selectedProductInstances: action.payload };
        case SET_SELECTED_LOT_SERIAL_INSTANCES:
            return { ...state, selectedLotSerialInstances: action.payload };
        case SET_IS_MARK_AS_CONSUMED_CLICKED:
            return { ...state, isMarkAsConsumedClicked: action.payload };
        case SET_IS_CONSUMPTION_SUMMARY_EDIT_CLICKED:
            return { ...state, isConsumptionSummaryEditClicked: action.payload };
        case SET_SCAN_SEARCH_ENABLED:
            return {
                ...state,
                searchData: {
                    ...state.searchData,
                    scanSearchEnabled: { ...state.searchData.scanSearchEnabled, ...action.payload },
                },
            };
        case SET_SEARCH_TERM:
            return {
                ...state,
                searchData: {
                    ...state.searchData,
                    searchTerm: { ...state.searchData.searchTerm, ...action.payload },
                },
            };
        case SET_PATIENT_DETAILS:
            return { ...state, patientDetails: action.payload };
        default:
            return state;
    }
};
